import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import CancelInternalButton from './CancelInternalButton';

export function InvoiceCancelInternal() {
  const {
    isNfe,
    isNfc,
    isNfs,
    useInternalInvoiceApiNfe,
    useInternalInvoiceApiNfc,
    useInternalInvoiceApiNfs,
    isInternalApiIssued,
  } = useInvoiceFormContext();

  if (isNfe && (useInternalInvoiceApiNfe || isInternalApiIssued)) {
    return <CancelInternalButton type={InvoiceType.NFE} />;
  }

  if (isNfc && (useInternalInvoiceApiNfc || isInternalApiIssued)) {
    return <CancelInternalButton type={InvoiceType.NFC} />;
  }

  if (isNfs && (useInternalInvoiceApiNfs || isInternalApiIssued)) {
    return <CancelInternalButton type={InvoiceType.NFS} />;
  }

  return null;
}
